import * as Sentry from "@sentry/react";
import { scrubTelemetryValue } from "./scrub.js";

let initialized = false;

export function initTelemetry(): void {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  const dsn = import.meta.env.VITE_SENTRY_DSN?.trim();
  const environment =
    import.meta.env.VITE_SENTRY_ENVIRONMENT?.trim() ||
    (import.meta.env.PROD ? "production" : "development");

  if (!dsn) {
    console.info(
      "[telemetry] VITE_SENTRY_DSN ausente — erros/eventos ficam no console (sink local).",
    );
    return;
  }

  const release = import.meta.env.VITE_SENTRY_RELEASE?.trim();

  Sentry.init({
    dsn,
    environment,
    ...(release ? { release } : {}),
    sendDefaultPii: false,
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.1),
    beforeSend(event) {
      return scrubTelemetryValue(event);
    },
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.data) {
        breadcrumb.data = scrubTelemetryValue(breadcrumb.data);
      }
      if (typeof breadcrumb.message === "string") {
        breadcrumb.message = scrubTelemetryValue(breadcrumb.message);
      }
      return breadcrumb;
    },
  });
}

export function captureUiError(error: unknown, hint?: string): void {
  const err = error instanceof Error ? error : new Error(String(error));
  if (!import.meta.env.VITE_SENTRY_DSN) {
    console.error("[telemetry:error]", hint ?? err.message, err);
    return;
  }
  Sentry.captureException(err, hint ? { tags: { ui_hint: hint } } : undefined);
}

/** Erro proposital para validar pilha legível (dev / debug). */
export function createTelemetryDebugError(): Error {
  const error = new Error("evolua.telemetry.debug_error");
  error.name = "TelemetryDebugError";
  return error;
}
